<template>
  <div class="main">
    <h1>Wichteln</h1>
    <div class="button-container">
      <router-link to="/create">
        <el-button type="danger" round>Neue Wichtelgruppe erstellen</el-button>
      </router-link>

      <router-link to="/manage">
        <el-button type="danger" round>Meine Wichtelgruppen verwalten</el-button>
      </router-link>

    </div>
    
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      width: 350px;
      height: 75px;
      font-size: 20px;
      margin: 0;
      margin-bottom: 15px;
    }
  }
}
</style>
